import React, { useEffect, useState } from "react";
import axios from "axios";
import DashboardLayout from "./DashboardLayout";

const API = "";

function AboutSetting() {
  const [form, setForm] = useState({
    about_text: "",
    director_message: "",
    mission: "",
    vision: "",
    affiliation_text: "",
    about_image: "",
    director_image: "",
    affiliation_image: "",
  });
  const [files, setFiles] = useState({});
  const [preview, setPreview] = useState({});
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const loadAboutData = async () => {
    try {
      const response = await axios.get(`${API}/api/about`);
      setForm((prev) => ({
        ...prev,
        ...(response.data || {}),
      }));
    } catch {
      setError("Failed to load about page settings");
    }
  };

  useEffect(() => {
    loadAboutData();
  }, []);

  const setField = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const handleFile = (key, file) => {
    if (!file) return;

    setFiles((prev) => ({ ...prev, [key]: file }));
    setPreview((prev) => ({ ...prev, [key]: URL.createObjectURL(file) }));
  };

  const saveAboutData = async () => {
    try {
      setSaving(true);
      setMessage("");
      setError("");

      const formData = new FormData();
      ["about_text", "director_message", "mission", "vision", "affiliation_text"].forEach((key) => {
        formData.append(key, form[key] || "");
      });

      Object.entries(files).forEach(([key, value]) => {
        if (value) {
          formData.append(key, value);
        }
      });

      await axios.post(`${API}/api/about`, formData);
      setFiles({});
      setPreview({});
      setMessage("About page settings saved successfully");
      loadAboutData();
    } catch {
      setError("About page settings save failed");
    } finally {
      setSaving(false);
    }
  };

  return (
    <DashboardLayout>
      <div className="container-fluid" style={{ display: "grid", gap: "22px" }}>
        <div>
          <h3 style={{ marginBottom: "6px" }}>About Us Page</h3>
          <p className="text-muted mb-0">
            About Institute, Director Message, Mission, Vision, and Affiliation & Recognition content এখান থেকেই control হবে।
          </p>
        </div>

        {message ? <div className="alert alert-success mb-0">{message}</div> : null}
        {error ? <div className="alert alert-danger mb-0">{error}</div> : null}

        <div className="card border-0 shadow-sm">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
              <div>
                <h5 className="mb-1">About Page Content Control</h5>
                <div className="text-muted">Now this is the only place to manage all about page content.</div>
              </div>
              <button type="button" className="btn btn-primary" onClick={saveAboutData} disabled={saving}>
                {saving ? "Saving..." : "Save About Content"}
              </button>
            </div>

            <div className="row g-4">
              <div className="col-lg-6">
                <div className="border rounded-4 p-3 bg-light h-100">
                  <label className="form-label fw-semibold">About Institute Text</label>
                  <textarea
                    className="form-control mb-3"
                    rows="7"
                    value={form.about_text || ""}
                    onChange={(event) => setField("about_text", event.target.value)}
                  />
                  <label className="form-label fw-semibold">About Institute Image</label>
                  <input type="file" className="form-control" onChange={(event) => handleFile("about_image", event.target.files?.[0] || null)} />
                  {(preview.about_image || form.about_image) ? (
                    <div className="mt-3 border rounded-3 p-2 bg-white">
                      <img
                        src={preview.about_image || `${API}/uploads/${form.about_image}`}
                        alt="About preview"
                        style={{ width: "100%", maxHeight: "220px", objectFit: "contain" }}
                      />
                    </div>
                  ) : null}
                </div>
              </div>

              <div className="col-lg-6">
                <div className="border rounded-4 p-3 bg-light h-100">
                  <label className="form-label fw-semibold">Director Message</label>
                  <textarea
                    className="form-control mb-3"
                    rows="7"
                    value={form.director_message || ""}
                    onChange={(event) => setField("director_message", event.target.value)}
                  />
                  <label className="form-label fw-semibold">Director Image</label>
                  <input type="file" className="form-control" onChange={(event) => handleFile("director_image", event.target.files?.[0] || null)} />
                  {(preview.director_image || form.director_image) ? (
                    <div className="mt-3 border rounded-3 p-2 bg-white">
                      <img
                        src={preview.director_image || `${API}/uploads/${form.director_image}`}
                        alt="Director preview"
                        style={{ width: "100%", maxHeight: "220px", objectFit: "contain" }}
                      />
                    </div>
                  ) : null}
                </div>
              </div>

              <div className="col-lg-6">
                <div className="border rounded-4 p-3 bg-light h-100">
                  <label className="form-label fw-semibold">Mission</label>
                  <textarea
                    className="form-control"
                    rows="7"
                    value={form.mission || ""}
                    onChange={(event) => setField("mission", event.target.value)}
                  />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="border rounded-4 p-3 bg-light h-100">
                  <label className="form-label fw-semibold">Vision</label>
                  <textarea
                    className="form-control"
                    rows="7"
                    value={form.vision || ""}
                    onChange={(event) => setField("vision", event.target.value)}
                  />
                </div>
              </div>

              <div className="col-12">
                <div className="border rounded-4 p-3 bg-light">
                  <label className="form-label fw-semibold">Affiliation & Recognition Text</label>
                  <textarea
                    className="form-control mb-3"
                    rows="6"
                    value={form.affiliation_text || ""}
                    onChange={(event) => setField("affiliation_text", event.target.value)}
                  />
                  <label className="form-label fw-semibold">Affiliation Image</label>
                  <input type="file" className="form-control" onChange={(event) => handleFile("affiliation_image", event.target.files?.[0] || null)} />
                  {(preview.affiliation_image || form.affiliation_image) ? (
                    <div className="mt-3 border rounded-3 p-2 bg-white">
                      <img
                        src={preview.affiliation_image || `${API}/uploads/${form.affiliation_image}`}
                        alt="Affiliation preview"
                        style={{ width: "100%", maxHeight: "220px", objectFit: "contain" }}
                      />
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
}

export default AboutSetting;
